import i18next from "i18next";
import { normalizePrice } from "../../../utils";
import { Button, PriceText, Wrapper } from "./style";

const MobileFloatingFooter = ({ totalPrice, currency, onContinue, disabled, isLoading, isVisible = true, buttonText }) => {
  const { t } = i18next;

  const defaultButtonText = buttonText || t("book_and_proceed_to_payment");

  return (
    <Wrapper $isVisible={isVisible}>
      <PriceText>
        <span className="label">{t("total")}:</span>
        <span className="amount">
          {normalizePrice(totalPrice)} {currency}
        </span>
      </PriceText>
      <Button onClick={onContinue} disabled={disabled || isLoading}>
        {isLoading ? t("processing") : defaultButtonText}
      </Button>
    </Wrapper>
  );
};

export default MobileFloatingFooter;

